(function () {
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];

  function addDays(d, n) {
    var r = new Date(d);
    r.setDate(r.getDate() + n);
    return r;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }

  function initEstimator(el) {
    if (el.dataset.deInit) return;
    el.dataset.deInit = '1';

    var c = el.dataset.country || '';
    var cn = el.dataset.countryName || '';
    var min, max;

    if (c === 'GB')                  { min = parseInt(el.dataset.ukMin)    || 4;  max = parseInt(el.dataset.ukMax)    || 10; }
    else if (c === 'US')             { min = parseInt(el.dataset.usMin)    || 7;  max = parseInt(el.dataset.usMax)    || 14; }
    else if (EU.indexOf(c) >= 0)     { min = parseInt(el.dataset.euMin)    || 6;  max = parseInt(el.dataset.euMax)    || 13; }
    else if (c === 'AU')             { min = parseInt(el.dataset.auMin)    || 7;  max = parseInt(el.dataset.auMax)    || 14; }
    else                             { min = parseInt(el.dataset.otherMin) || 10; max = parseInt(el.dataset.otherMax) || 21; }

    var today = new Date();
    var lbl = el.querySelector('.t4s-de__label');
    var dts = el.querySelector('.t4s-de__dates');
    var label = el.dataset.label || 'Estimated Delivery';

    if (lbl) lbl.textContent = label + (cn ? ' to ' + cn : '') + ': ';
    if (dts) dts.textContent = fmt(addDays(today, min)) + ' – ' + fmt(addDays(today, max));
  }

  function initAll() {
    document.querySelectorAll('.t4s-delivery-estimator').forEach(initEstimator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('.t4s-delivery-estimator') || e.target.querySelector('.t4s-delivery-estimator');
    if (el) initEstimator(el);
  });
})();
